import Vue from 'vue';
import VueRouter from 'vue-router';
// import Home from '../views/Home.vue'

import Login from '../views/user/Login.vue';
import Survey from '../views/survey/Index.vue';

import Layout from '../views/Layout.vue';

import Test from '../views/test/Index.vue';
import TestGroup from '../views/test/Group.vue';
import Testing from '../views/test/Testing.vue';

import Lectures from '../views/lecture/Index.vue';
import Lecture from '../views/lecture/Lecture.vue';

import $ from 'jquery';
import "jquery.cookie";

Vue.use( VueRouter );

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Layout,
		redirect: '/login',
		children: [
			// test
			// lecture
			{
				path: '/test/',
				name: 'Test',
				component: Test
			}, {
				path: '/test/:Group',
				name: 'Test Group',
				component: TestGroup
			}, {
				path: '/test/:Group/:index',
				name: 'Testing',
				component: Testing
			}, {
				path: '/lecture/',
				name: 'Lectures',
				component: Lectures,
				redirect: '/lecture/1',
				children: [
					{
						path: '/lecture/:index',
						name: 'Lecture',
						component: Lecture
					}
				]
			},
		]
	}, {
		path: '/login/',
		name: 'Login',
		component: Login
	}, {
		path: '/survey/',
		name: 'Survey',
		component: Survey
	}
];

const router = new VueRouter( {
	mode: 'history',
	base: process.env.BASE_URL,
	routes
} );

router.beforeEach( ( to, from, next ) => {
	const userData = localStorage.getItem( "userData" );
	const token = $.cookie( "SMA" );

	if ( to.name !== "Login" ) {
		if ( token === undefined || userData === null ) {
			next( { name: "Login" } );
		} else {
			if ( to.name !== "Survey" ) {
				if ( JSON.parse( userData ).survay === "Y" ) {
					next();
				} else {
					next( { name: "Survey" } );
				}
			} else {
				if ( JSON.parse( userData ).survay === "N" ) {
					next();
				} else {
					next( { name: "Test" } );
				}
			}
		}
	} else {
		if ( token === undefined || userData === null ) {
			next();
		} else {
			next( { name: "Survey" } );
		}
	}

} );

export default router;
